export default "/images/153d244175625c30aedf05ea0896b1c2.avif";